export const randomString = () => Math.random().toString(36).substr(2, 5).toUpperCase();

export const randomNumber = () => Math.floor(Math.random() * 9000) + 1000;
